import React from 'react';
import { FaTimes, FaEdit, FaSave } from 'react-icons/fa';
import { StudentProfile } from '../../../lib/database.types';
import '../OJTCoordinator.css';
import './ProgramStat.css';

// Card Component
interface TotalStudentsCardProps {
  count: number;
  onClick: () => void;
}

export const TotalStudentsCard: React.FC<TotalStudentsCardProps> = ({ count, onClick }) => {
  return (
    <div className="stat-card clickable" onClick={onClick}>
      <div className="stat-number">{count}</div>
      <div className="stat-label">Total Students</div>
    </div>
  );
};

// Modal Component
interface TotalStudentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  students: StudentProfile[];
  editingStudentId: string | null;
  editingDepartment: string;
  editingSupervisor: string;
  onEditDepartment: (student: StudentProfile) => void;
  onSaveDepartment: (student: StudentProfile) => void;
  onCancelEdit: () => void;
  onDepartmentChange: (value: string) => void;
  onSupervisorChange: (value: string) => void;
  offices: string[];
  officesLoading: boolean;
}

export const TotalStudentsModal: React.FC<TotalStudentsModalProps> = ({
  isOpen,
  onClose,
  students,
  editingStudentId,
  editingDepartment,
  editingSupervisor,
  onEditDepartment,
  onSaveDepartment,
  onCancelEdit,
  onDepartmentChange,
  onSupervisorChange,
  offices,
  officesLoading,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content students-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>All Students - Department & Supervisor Management</h2>
          <button className="close-modal-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="modal-body">
          <div className="students-table-container">
            <table className="students-table">
              <thead>
                <tr>
                  <th>Student ID</th>
                  <th>Name</th>
                  <th>Department</th>
                  <th>Supervisor</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {students.map((student) => (
                  <tr key={student.id}>
                    <td>{student.student_id}</td>
                    <td>{student.first_name} {student.last_name}</td>
                    <td>
                      {editingStudentId === student.id ? (
                        <select
                          value={editingDepartment}
                          onChange={(e) => onDepartmentChange(e.target.value)}
                          className="department-select"
                          disabled={officesLoading}
                          autoFocus
                        >
                          <option value="">
                            {officesLoading ? 'Loading...' : 'Select department'}
                          </option>
                          {offices.map((office) => (
                            <option key={office} value={office}>
                              {office}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span className="department-badge">{student.department}</span>
                      )}
                    </td>
                    <td>
                      {editingStudentId === student.id ? (
                        <input
                          type="text"
                          value={editingSupervisor}
                          onChange={(e) => onSupervisorChange(e.target.value)}
                          className="supervisor-input"
                          placeholder="Enter supervisor name"
                        />
                      ) : (
                        <span>{student.supervisor || 'N/A'}</span>
                      )}
                    </td>
                    <td>
                      {editingStudentId === student.id ? (
                        <div className="action-buttons">
                          <button 
                            className="save-btn"
                            onClick={() => onSaveDepartment(student)}
                            title="Save"
                          >
                            <FaSave />
                          </button>
                          <button 
                            className="cancel-btn"
                            onClick={onCancelEdit}
                            title="Cancel"
                          >
                            <FaTimes />
                          </button>
                        </div>
                      ) : (
                        <button 
                          className="edit-btn"
                          onClick={() => onEditDepartment(student)}
                          title="Edit Department & Supervisor"
                        >
                          <FaEdit />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

